import { render, staticRenderFns } from "./classEnvSec.vue?vue&type=template&id=22411246&scoped=true&"
import script from "./classEnvSec.vue?vue&type=script&lang=js&"
export * from "./classEnvSec.vue?vue&type=script&lang=js&"
import style0 from "./classEnvSec.vue?vue&type=style&index=0&id=22411246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22411246",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
